"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Nav = void 0;

var _react = _interopRequireWildcard(require("react"));

var _theming = require("@storybook/theming");

var _designSystem = require("@storybook/design-system");

var _icons = require("@storybook/icons");

var _styles = require("../shared/styles");

var _NavItem = require("./NavItem");

var _Search = require("../Search");

var _TabletMenu = require("./TabletMenu");

var _MobileMenu = require("./MobileMenu");

var _linksContext = require("../links-context");

var _GithubButton = require("../GithubButton");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var navBreakpoints = {
  desktop: 978,
  tablet: _styles.breakpoints[1],
  mobile: _styles.breakpoints[0]
};
var GlobalSearch = ( /*#__PURE__*/0, _theming.styled)(_Search.Search, process.env.NODE_ENV === "production" ? {
  target: "e1skfx0212"
} : {
  target: "e1skfx0212",
  label: "GlobalSearch"
})(function (props) {
  return props.monochrome && " --search-keys-bg: rgba(255, 255, 255, 0.1);";
}, " flex:none;width:160px;display:none;@media (min-width: ", navBreakpoints.tablet, "px){display:block;}@media (min-width: ", navBreakpoints.tablet, "px){position:absolute;left:50%;transform:translateX(-50%);}@media (min-width: ", navBreakpoints.desktop, "px){position:relative;left:initial;transform:initial;margin-left:auto;}");
var LogoNavItem = ( /*#__PURE__*/0, _theming.styled)(_NavItem.NavItem, process.env.NODE_ENV === "production" ? {
  target: "e1skfx0211"
} : {
  target: "e1skfx0211",
  label: "LogoNavItem"
})("background-color:transparent;&:hover,&:focus,&:active{background-color:transparent;outline:2px solid ", _styles.color.secondary, ";}@media (min-width: ", navBreakpoints.desktop, "px){margin-right:24px;}");
var StorybookLogo = ( /*#__PURE__*/0, _theming.styled)(_designSystem.Logos.Storybook, process.env.NODE_ENV === "production" ? {
  target: "e1skfx0210"
} : {
  target: "e1skfx0210",
  label: "StorybookLogo"
})(process.env.NODE_ENV === "production" ? {
  name: "1r6i2mo",
  styles: "height:20px;display:block"
} : {
  name: "1r6i2mo",
  styles: "height:20px;display:block",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var StorybookLogoInverse = ( /*#__PURE__*/0, _theming.styled)(_designSystem.Logos.StorybookInverted, process.env.NODE_ENV === "production" ? {
  target: "e1skfx029"
} : {
  target: "e1skfx029",
  label: "StorybookLogoInverse"
})(process.env.NODE_ENV === "production" ? {
  name: "1r6i2mo",
  styles: "height:20px;display:block"
} : {
  name: "1r6i2mo",
  styles: "height:20px;display:block",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var Wrapper = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1skfx028"
} : {
  target: "e1skfx028",
  label: "Wrapper"
})("position:relative;z-index:20;box-shadow:", function (props) {
  return props.inverse ? 'rgba(255, 255, 255, 0.1)' : _styles.color.tr10;
}, " 0 -1px 0px 0px inset;padding-top:", _styles.spacing.padding.medium, "px;padding-bottom:", _styles.spacing.padding.medium, "px;");
var NavContainer = (0, _theming.styled)("nav", process.env.NODE_ENV === "production" ? {
  target: "e1skfx027"
} : {
  target: "e1skfx027",
  label: "NavContainer"
})(_styles.pageMargins, " display:flex;align-items:center;justify-content:space-between;"); // Tablet nav 600 - desktop

var TabletNav = ( /*#__PURE__*/0, _theming.styled)(_TabletMenu.TabletMenu, process.env.NODE_ENV === "production" ? {
  target: "e1skfx026"
} : {
  target: "e1skfx026",
  label: "TabletNav"
})("display:none;@media (min-width: ", navBreakpoints.tablet, "px){display:block;}@media (min-width: ", navBreakpoints.desktop, "px){display:none;}"); // Mobile nav 0 - 600

var MobileNav = ( /*#__PURE__*/0, _theming.styled)(_MobileMenu.MobileMenu, process.env.NODE_ENV === "production" ? {
  target: "e1skfx025"
} : {
  target: "e1skfx025",
  label: "MobileNav"
})("display:block;@media (min-width: ", navBreakpoints.tablet, "px){display:none;}");
var Arrow = ( /*#__PURE__*/0, _theming.styled)(_icons.ArrowTopRightIcon, process.env.NODE_ENV === "production" ? {
  target: "e1skfx024"
} : {
  target: "e1skfx024",
  label: "Arrow"
})(process.env.NODE_ENV === "production" ? {
  name: "15v2m24",
  styles: "margin-bottom:8px;margin-left:6px"
} : {
  name: "15v2m24",
  styles: "margin-bottom:8px;margin-left:6px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var NavLinks = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1skfx023"
} : {
  target: "e1skfx023",
  label: "NavLinks"
})("display:none;align-items:center;>*{margin-right:9px;}@media (min-width: ", navBreakpoints.desktop, "px){display:flex;}");
var Left = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1skfx022"
} : {
  target: "e1skfx022",
  label: "Left"
})(process.env.NODE_ENV === "production" ? {
  name: "ye2gio",
  styles: "display:flex;align-items:center;flex-direction:row"
} : {
  name: "ye2gio",
  styles: "display:flex;align-items:center;flex-direction:row",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var Right = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1skfx021"
} : {
  target: "e1skfx021",
  label: "Right"
})(process.env.NODE_ENV === "production" ? {
  name: "fkxplm",
  styles: "display:flex;align-items:center;flex-direction:row;gap:12px"
} : {
  name: "fkxplm",
  styles: "display:flex;align-items:center;flex-direction:row;gap:12px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var GithubButtonWrapper = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1skfx020"
} : {
  target: "e1skfx020",
  label: "GithubButtonWrapper"
})("margin-left:", _styles.spacing.padding.medium, "px;flex:none;display:none;@media (min-width: 1224px){display:block;}");

var Nav = function Nav(_ref) {
  var inverse = _ref.inverse,
      monochrome = _ref.monochrome,
      _ref$version = _ref.version,
      version = _ref$version === void 0 ? '6.5' : _ref$version,
      apiKey = _ref.apiKey,
      _ref$activeSection = _ref.activeSection,
      activeSection = _ref$activeSection === void 0 ? 'home' : _ref$activeSection,
      _ref$githubStarCount = _ref.githubStarCount,
      githubStarCount = _ref$githubStarCount === void 0 ? 8000 : _ref$githubStarCount;
  var navLinks = (0, _react.useContext)(_linksContext.LinksContext);
  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    inverse: inverse
  }, /*#__PURE__*/_react["default"].createElement(NavContainer, null, /*#__PURE__*/_react["default"].createElement(Left, null, /*#__PURE__*/_react["default"].createElement(LogoNavItem, {
    "aria-label": "home",
    href: navLinks.home.url,
    LinkWrapper: navLinks.home.linkWrapper
  }, inverse ? /*#__PURE__*/_react["default"].createElement(StorybookLogoInverse, {
    role: "presentation"
  }) : /*#__PURE__*/_react["default"].createElement(StorybookLogo, {
    role: "presentation"
  })), /*#__PURE__*/_react["default"].createElement(NavLinks, null, /*#__PURE__*/_react["default"].createElement(_NavItem.NavItem, {
    active: activeSection === 'docs',
    monochrome: monochrome,
    variant: inverse ? 'inverse' : 'default',
    href: navLinks.guides.url,
    LinkWrapper: navLinks.showcase.linkWrapper
  }, "Docs"), /*#__PURE__*/_react["default"].createElement(_NavItem.NavItem, {
    active: activeSection === 'integrations',
    monochrome: monochrome,
    variant: inverse ? 'inverse' : 'default',
    href: navLinks.integrations.url,
    LinkWrapper: navLinks.integrations.linkWrapper
  }, "Addons"), /*#__PURE__*/_react["default"].createElement(_NavItem.NavItem, {
    active: activeSection === 'showcase',
    monochrome: monochrome,
    variant: inverse ? 'inverse' : 'default',
    href: navLinks.showcase.url,
    LinkWrapper: navLinks.showcase.linkWrapper
  }, "Showcase"), /*#__PURE__*/_react["default"].createElement(_NavItem.NavItem, {
    active: activeSection === 'blog',
    monochrome: monochrome,
    variant: inverse ? 'inverse' : 'default',
    href: navLinks.blog.url,
    LinkWrapper: navLinks.blog.linkWrapper
  }, "Blog"), /*#__PURE__*/_react["default"].createElement(_NavItem.NavItem, {
    active: activeSection === 'blog',
    monochrome: monochrome,
    variant: inverse ? 'inverse' : 'default',
    href: navLinks.chromatic.url,
    LinkWrapper: navLinks.chromatic.linkWrapper
  }, "Visual Test", /*#__PURE__*/_react["default"].createElement(Arrow, {
    size: 8
  })), /*#__PURE__*/_react["default"].createElement(_NavItem.NavItem, {
    monochrome: monochrome,
    variant: inverse ? 'inverse' : 'default',
    href: navLinks.enterprise.url,
    LinkWrapper: navLinks.enterprise.linkWrapper
  }, "Enterprise", /*#__PURE__*/_react["default"].createElement(Arrow, {
    size: 8
  })))), /*#__PURE__*/_react["default"].createElement(Right, null, /*#__PURE__*/_react["default"].createElement(GithubButtonWrapper, null, /*#__PURE__*/_react["default"].createElement(_GithubButton.GithubButton, {
    starCount: githubStarCount,
    inverse: inverse
  })), /*#__PURE__*/_react["default"].createElement(GlobalSearch, {
    monochrome: monochrome,
    apiKey: apiKey,
    version: version,
    inverse: inverse
  })), /*#__PURE__*/_react["default"].createElement(TabletNav, {
    navLinks: navLinks,
    inverse: inverse,
    monochrome: monochrome
  }), /*#__PURE__*/_react["default"].createElement(MobileNav, {
    navLinks: navLinks,
    inverse: inverse,
    monochrome: monochrome,
    apiKey: apiKey,
    version: version
  })));
};

exports.Nav = Nav;